export default __webpack_public_path__ + "static/media/PropertyDev_IMG-Istana.a2e3df68.png";